module.exports = __webpack_public_path__ + "media/flags/be-flag-33027a5e.svg";